import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/Home";
import Tramite from "@/components/pages/Tramite";
import Solicitud from "@/components/pages/Solicitud";
import Seguimiento from "@/components/pages/Seguimiento";
import Verificar from "@/components/pages/Verificar";
import Contacto from "@/components/pages/Contacto";
import Openid from "@/components/pages/Openid";
import Ppetramite from "@/components/pages/pperedirect";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Openid",
      component: Openid
    },
    {
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/tramite",
      name: "Tramite",
      component: Tramite
    },
    {
      path: "/solicitud",
      name: "Solicitud",
      component: Solicitud
    },
    {
      path: "/seguimiento",
      name: "Seguimiento",
      component: Seguimiento
    },
    {
      path: "/verificar/:nro_legalizacion?/:cod_seguridad?/:fecha_expedicion?",
      name: "Verificar",
      component: Verificar
    },
    {
      path: "/contacto",
      name: "Contacto",
      component: Contacto
    },
    {
      path: "/ppe/tramite",
      name: "ppeTramite",
      component: Ppetramite
    }
  ]
});

router.beforeEach((to, from, next) => {
  const app = router.app || {};

  const clearOidcSession = () => {
    sessionStorage.removeItem("legalizacion-web_access_token");
    sessionStorage.removeItem("legalizacion-web_refresh_token");
    sessionStorage.removeItem("legalizacion-web_expires_at");
  };

  const redirectToOidcLogin = () => {
    if (app.$serviceoidc) {
      clearOidcSession();
      window.location.replace(app.$serviceoidc.getOidc());
    } else {
      next({ name: "Openid" });
    }
  };

  // Si ya hay un token OIDC, evitar quedarse en la pantalla de callback y
  // llevar al usuario al Home. Si el token expiró, el guardia de Home lo
  // redirigirá a Ciudadanía Digital.
  if (to.name === "Openid" && sessionStorage.getItem("legalizacion-web_access_token")) {
    return next({ name: "Home" });
  }

  if (to.name === "Openid" || to.name === "ppeTramite") {
    next();
  } else if (sessionStorage.getItem("legalizacion-web_access_token")) {
    app.$serviceoidc
      .refreshTokenIfNeeded()
      .then(() => {
        const token = sessionStorage.getItem("legalizacion-web_access_token");
        return app.$serviceoidc.postVerificaToken(token);
      })
      .then(response => {
        if (response && response.active) {
          console.log("token verificado y correcto");
          return next();
        } else {
          console.log("token inactivo o invalido");
          return redirectToOidcLogin();
        }
      })
      .catch(error => {
        console.log("error verificando/refrescando token", error);
        return redirectToOidcLogin();
      });
  } else {
    redirectToOidcLogin();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js